/** #309: a scheduled Riley report (`/reports/<uuid>`), saved for a person and delivered through their digest. */
import { ReportCard } from '@patchbay/ui'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { Frame, PaneHeader } from '../../components/frame'
import { api } from '../admin/api'

export const reportQuery = (id: string) => queryOptions({ queryKey: ['reports', id], queryFn: () => api.report(id) })

export function ReportScreen({ id }: { id: string }) {
  const { data } = useSuspenseQuery(reportQuery(id))
  return (
    <Frame
      active="home"
      railless
      main={
        <div className="flex h-full flex-col overflow-y-auto">
          <PaneHeader title={data.artifact.title} subtitle="Saved for you by Riley and delivered through your digest." />
          <main className="w-full max-w-6xl p-5">
            <ReportCard report={data.artifact} />
          </main>
        </div>
      }
    />
  )
}
